import { render, staticRenderFns } from "./_MessagesWrapper.vue?vue&type=template&id=7d5f3a08&scoped=true&"
import script from "./_MessagesWrapper.vue?vue&type=script&lang=js&"
export * from "./_MessagesWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5f3a08",
  null
  
)

export default component.exports